"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _errorMessage = require("./errorMessage.style");
const ErrorMessage = _ref => {
  let {
    errorMessage
  } = _ref;
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: errorMessage && (0, _jsxRuntime.jsx)(_errorMessage.Components.Message, {
      children: errorMessage
    })
  });
};
var _default = exports["default"] = ErrorMessage;